import { NETWORKS } from './constants'
import loadScript from 'lib/window/loadScript'

function init() {
  loadScript('https://platform-api.sharethis.com/js/sharethis.js#product=custom-share-buttons', { async: true }).then(() => {
    if (window.__sharethis__) {
      const shareThisConfig = {
        id: 'sharethis-' + Date.now(),
        alignment: 'center',
        color: 'social',
        enabled: true,
        font_size: 16,
        labels: 'cta',
        language: 'en',
        networks: NETWORKS.map((network) => network.key),
        padding: 12,
        radius: 4,
        show_total: false,
        size: 40,
      }
      window.__sharethis__.load('custom-share-buttons', shareThisConfig)
    }
  })
}

export default init
